import Swiper from "swiper/bundle";

export const subscriptionReviews = () => {

    const $subscriptionReviews = document.querySelector(
        "section.subscription-reviews"
    );

    if ($subscriptionReviews) {
        const $subscriptionPopularWrapper = $subscriptionReviews.querySelector(
            ".subscription-reviews__wrapper"
        );

        const $wrapperContents = $subscriptionPopularWrapper?.querySelector(".wrapper__contents");
        const $navLeft = $subscriptionPopularWrapper?.querySelector(".nav__left .left__button");
        const $navRight = $subscriptionPopularWrapper?.querySelector(".nav__right .right__button");

        if ($wrapperContents && $navLeft && $navRight) {
            const $wrapperSwiper = $wrapperContents.querySelector(".contents__swiper.swiper");
            if ($wrapperSwiper) {
                const swiperConfig = {
                    direction: "horizontal",
                    speed: 1000,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 12,
                };
                if ($navLeft && $navRight) {
                    swiperConfig.navigation = {
                        nextEl: $navRight,
                        prevEl: $navLeft,
                    };
                }
                const swiperObject = new Swiper($wrapperSwiper, swiperConfig);
            }
        }
    }
};

export default subscriptionReviews;